import { makeContextModule } from '@cian/react-utils';

import { type IApplicationContext } from '@/app/shared/types/ApplicationContext';

export const {
  Context: { Provider: ApplicationContextProvider, Consumer: ApplicationContextConsumer },
  useContext: useApplicationContext,
  withContext: withApplicationContext,
} = makeContextModule<IApplicationContext>({
  contextName: 'ApplicationContext',
});
